import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { message } from "antd";

import { QuestionnaireAction } from "../../store/actions";

import {
  Buttons,
  Spacer,
  boxContainer,
  questionnaireComponents,
  inputFields,
  Loader,
  checkbox,
} from "../../components";

import "./styles.css";

const ContactProfileBuilder = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const profileData = useSelector((state) => state.profile?.user);

  const { questionnaire, isLoading } = useSelector(
    (state) => state?.questionnaire
  );

  const [same, setSame] = useState(false);
  const [contacts, setContacts] = useState({
    emergencyName: "",
    emergencyRelation: "",
    emergencyEmail: "",
    emergencyPhone: "",
    guardianName: "",
    guardianRelation: "",
    guardianEmail: "",
    guardianPhone: "",
  });

  useEffect(() => {
    getQuestionnaire();
  }, [profileData]);

  useEffect(() => {
    setContacts({
      emergencyName: questionnaire?.emergencyName,
      emergencyRelation: questionnaire?.emergencyRelation,
      emergencyEmail: questionnaire?.emergencyEmail,
      emergencyPhone: questionnaire?.emergencyPhone,
      guardianName: questionnaire?.guardianName,
      guardianRelation: questionnaire?.guardianRelation,
      guardianEmail: questionnaire?.guardianEmail,
      guardianPhone: questionnaire?.guardianPhone,
    });
    if (
      questionnaire?.emergencyName &&
      questionnaire?.emergencyName === questionnaire?.guardianName &&
      questionnaire?.emergencyRelation &&
      questionnaire?.emergencyRelation === questionnaire?.guardianRelation &&
      questionnaire?.emergencyEmail === questionnaire?.guardianEmail &&
      questionnaire?.emergencyPhone &&
      questionnaire?.emergencyPhone === questionnaire?.guardianPhone
    ) {
      setSame(true);
    }
  }, [questionnaire]);

  useEffect(() => {
    if (same) {
      setContacts((prev) => ({
        ...prev,
        guardianName: prev.emergencyName,
        guardianRelation: prev.emergencyRelation,
        guardianEmail: prev.emergencyEmail,
        guardianPhone: prev.emergencyPhone,
      }));
    }
  }, [
    same,
    contacts.emergencyName,
    contacts.emergencyRelation,
    contacts.emergencyEmail,
    contacts.emergencyPhone,
  ]);

  const getQuestionnaire = () => {
    dispatch(QuestionnaireAction.getQuestionnaire());
  };

  const handleNext = () => {
    if (
      !contacts.emergencyName &&
      !contacts.emergencyRelation &&
      !contacts.emergencyPhone
    ) {
      message.error("Please fill all the required fields.");
    } else {
      const payload = { userId: profileData?.id, ...contacts };

      dispatch(
        QuestionnaireAction.addQuestionnaire(payload, (res) => {
          if (res.status === 200) {
            navigate("/profile-builder/counselor");
          }
          getQuestionnaire();
        })
      );
    }
  };

  return (
    <div className="text-black">
      <div className="header-md pl-2 flex gap-2 items-center">
        Emergency Contact
      </div>
      <Spacer height={10} />
      {isLoading ? (
        <Loader.Circular />
      ) : (
        <boxContainer.LiteBoxContainer>
          <div>
            <div className="section-header">Emergency Contact</div>
            <div className="grid grid-cols-2 gap-x-7 gap-y-6">
              <div>
                <questionnaireComponents.QuestionnaireLabel
                  text="Name"
                  required
                />
                <Spacer height={5} />
                <inputFields.DefaultInput
                  onChange={(e) =>
                    setContacts({ ...contacts, emergencyName: e.target.value })
                  }
                  placeholder="Enter name"
                  value={contacts.emergencyName}
                />
              </div>
              <div>
                <questionnaireComponents.QuestionnaireLabel
                  text="Relation"
                  required
                />
                <Spacer height={5} />
                <inputFields.DefaultInput
                  onChange={(e) =>
                    setContacts({
                      ...contacts,
                      emergencyRelation: e.target.value,
                    })
                  }
                  placeholder="Enter relationship"
                  value={contacts.emergencyRelation}
                />
              </div>
              <div>
                <questionnaireComponents.QuestionnaireLabel text="Email" />
                <Spacer height={5} />
                <inputFields.DefaultInput
                  onChange={(e) =>
                    setContacts({ ...contacts, emergencyEmail: e.target.value })
                  }
                  placeholder="Enter name"
                  type="email"
                  value={contacts.emergencyEmail}
                />
              </div>
              <div>
                <questionnaireComponents.QuestionnaireLabel
                  text="Phone Number"
                  required
                />
                <Spacer height={5} />
                <inputFields.DefaultPhoneInput
                  onChange={(e) =>
                    setContacts({ ...contacts, emergencyPhone: e })
                  }
                  value={contacts?.emergencyPhone}
                />
              </div>
            </div>
          </div>

          <Spacer height={20} />
          <div>
            <div className="section-header">Guardian</div>
            <div className="grid grid-cols-2 gap-x-7 gap-y-6">
              <div>
                <questionnaireComponents.QuestionnaireLabel text="Name" />
                <Spacer height={5} />
                <inputFields.DefaultInput
                  onChange={(e) =>
                    setContacts({ ...contacts, guardianName: e.target.value })
                  }
                  placeholder="Enter name"
                  value={contacts.guardianName}
                  disabled={same}
                />
              </div>
              <div>
                <questionnaireComponents.QuestionnaireLabel text="Relation" />
                <Spacer height={5} />
                <inputFields.DefaultInput
                  onChange={(e) =>
                    setContacts({
                      ...contacts,
                      guardianRelation: e.target.value,
                    })
                  }
                  placeholder="Enter relationship"
                  value={contacts.guardianRelation}
                  disabled={same}
                />
              </div>
              <div>
                <questionnaireComponents.QuestionnaireLabel text="Email" />
                <Spacer height={5} />
                <inputFields.DefaultInput
                  onChange={(e) =>
                    setContacts({ ...contacts, guardianEmail: e.target.value })
                  }
                  placeholder="Enter name"
                  type="email"
                  value={contacts.guardianEmail}
                  disabled={same}
                />
              </div>
              <div>
                <questionnaireComponents.QuestionnaireLabel text="Phone Number" />
                <Spacer height={5} />
                <inputFields.DefaultPhoneInput
                  onChange={(e) =>
                    setContacts({ ...contacts, guardianPhone: e })
                  }
                  value={contacts?.guardianPhone}
                  disabled={same}
                />
              </div>
            </div>
            <Spacer height={5} />
            <checkbox.DefaultCheckbox
              text="Same as emergency contact"
              onChange={(e) => {
                setSame(e.target.checked);
              }}
              checked={same}
            />
          </div>
          <Spacer height={20} />
          <div className="flex justify-end">
            <div className="w-[12.5em]">
              <Buttons.DefaultButton
                onClick={handleNext}
                size="large"
                width="full"
              >
                Next
              </Buttons.DefaultButton>
            </div>
          </div>
        </boxContainer.LiteBoxContainer>
      )}
    </div>
  );
};

export default ContactProfileBuilder;
